const FetchStatus = {
    DEFAULT: -1,
    SUCCESS: 0,
    ACTIVE: 1,
    ERROR: 2
};

Object.freeze(FetchStatus);

export default FetchStatus;